import {
  setToken
  //  getToken, deleteToken
} from "../../utils/token";

// Action Types
export const actionTypes = {
  GET_PROPERTIES: "GET_PROPERTIES",
  GET_PROPERTIES_SUCCESS: "GET_PROPERTIES_SUCCESS",
  GET_PROPERTIES_FAILED: "GET_PROPERTIES_FAILED",

  GET_BUILDINGS: "GET_BUILDINGS",
  GET_BUILDINGS_SUCCESS: "GET_BUILDINGS_SUCCESS",
  GET_BUILDINGS_FAILED: "GET_BUILDINGS_FAILED",

  GET_UNITS: "GET_UNITS",
  GET_UNITS_SUCCESS: "GET_UNITS_SUCCESS",
  GET_UNITS_FAILED: "GET_UNITS_FAILED"
};

// Action creators
export const actionCreators = {
  getProperties: params => ({
    type: actionTypes.GET_PROPERTIES,
    params
  }),
  getBuildings: params => ({
    type: actionTypes.GET_BUILDINGS,
    params
  }),
  getUnits: params => ({
    type: actionTypes.GET_UNITS,
    params
  })
};

// Reducer
const initialState = {
  data: [],
  buildings: [],
  units: [],
  meta: null,
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_UNITS:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        units: []
      });

    case actionTypes.GET_BUILDINGS:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        buildings: []
      });

    case actionTypes.GET_PROPERTIES:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        // data: []
      });

    case actionTypes.GET_PROPERTIES_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        data: action.payload
      });

    case actionTypes.GET_BUILDINGS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        buildings: action.payload
      });

    case actionTypes.GET_UNITS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        units: action.payload
      });

    case actionTypes.GET_UNITS_FAILED:
    case actionTypes.GET_BUILDINGS_FAILED:
    case actionTypes.GET_PROPERTIES_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error
      });

    default:
      return state;
  }
};
